<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" :layer="layer">
      <template #top v-if="masterplanSquaresReportVisible">
        <sidebar-row class="pr-5 pt-3">
          <v-row no-gutters>
            <v-col cols="auto">
              <base-button
                class="mb-2 text-body-2"
                translation-path="sidebar.requirementsCard"
                @click="generateReport"
                :loading="loading"
              />
            </v-col>
          </v-row>
        </sidebar-row>
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import FeatureCardBasic from '@/components/FeatureCardBasic';
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'FeatureCardMasterplanSquares',
  components: { FeatureCardBasic, SidebarRow },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    isAdminEnabled: get('admin/settingsValues@masterplan_squares_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@MASTERPLAN_SQUARES.enabled'),
    modulesPermissions: get('users/toolsPermissions'),
    currentFeatureId() {
      return this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    masterplanSquaresReportVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permissions.preview;
    },
    permissions() {
      const value = this.modulesPermissions['MASTERPLAN_SQUARES'].main_value;
      return {
        edit: value > 1,
        preview: value > 0,
        value,
      };
    },
  },
  methods: {
    getFeatureReport: call('zdm/getFeatureReport'),
    async generateReport() {
      this.loading = true;
      try {
        const payload = {
          layerId: this.layer.id,
          featureId: this.currentFeatureId,
        };
        await this.getFeatureReport(payload);
        this.loading = false;
      } catch {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
